import {useState, useEffect} from "react";
import {useRequestGet} from "./useRequestGet";

export function useDataCollectionRequest ( url, params = {}, method, refresh = false ) {

    const { data } = useRequestGet(url, params, refresh);

    const [dataCollectionRequest, setDataCollectionRequest] = useState(null);
    const [error, setError] = useState(null);
    
    useEffect(() => {

            try {
                if (data) {
                    if (method === 'row') {
                        setDataCollectionRequest(data[0]);

                    } else {
                        setDataCollectionRequest(data);
                    }
                }

            } catch (error) {
                setError(error);
            }

    },[data, method]);


    return {
        dataCollectionRequest,
        setDataCollectionRequest,
        error
    };
}